import { useMutation, useQueryClient } from 'react-query';

import { deleteEmployerCostSettings } from 'RestAPIs/admin';

import { showErrorSnackbar } from 'components/shared/Snackbar';

export const useDelete = () => {
  const queryClient = useQueryClient();
  return useMutation((id: number) => deleteEmployerCostSettings(id), {
    onSuccess: async () => {
      await queryClient.invalidateQueries(['EmployerCostSettings', 'list']);
    },
    onError: () => {
      showErrorSnackbar();
    }
  });
};
